import React from 'react';
import { Link } from 'react-router-dom';

import './require-feature.scss';

/**
 * What a signed-in RC admin with no store sees instead of a store page
 * (L12). Shown by CustomRoute (layouts/Route.jsx); same card as the
 * locked-feature screen so it reads as part of the app, not an error.
 */
export function NoStoreYet() {
  return (
    <div className="rc-locked-feature">
      <div className="rc-locked-feature__card">
        <h3>Your store isn&apos;t set up yet</h3>
        <p>
          Ask your store owner to finish your invite. You&apos;ll see your store here as soon as
          it&apos;s ready.
        </p>
        <Link to="/logout" className="rc-btn rc-btn--small">
          Sign out
        </Link>
      </div>
    </div>
  );
}

export default NoStoreYet;
